import React, { useEffect } from "react";
import Hero from "./Hero/Hero.jsx";
import Footer from "../../Components/Footer/Footer.js";
import TextContent from "./TextContent/TextContent.jsx";
import Form from "./Form/DonationForm.jsx";
import Qrcodes from "./QRCodes/Qrcodes.jsx";
// import { Helmet } from "react-helmet-async";

const DasaraMahotsav2025 = () => {
  // const eventSchema = {
  //   "@context": "https://schema.org",
  //   "@type": "Event",
  //   name: "Sri Radhastami Celebrations 2025",
  //   startDate: "2025-08-31T10:00:00+05:30",
  //   endDate: "2025-08-31T14:00:00+05:30",
  //   eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
  //   eventStatus: "https://schema.org/EventScheduled",
  //   location: {
  //     "@type": "Place",
  //     name: "ISKCON Vijayawada Sri Sri Radha Syam Sundar Mandir",
  //     address: {
  //       "@type": "PostalAddress",
  //       streetAddress:
  //         "ISKCON Sri Jagannath Mandir, Skew Bridge, Ramalingeswara Nagar",
  //       addressLocality: "Vijayawada",
  //       addressRegion: "Andhra Pradesh",
  //       postalCode: "520013",
  //       addressCountry: "IN",
  //     },
  //   },
  //   organizer: {
  //     "@type": "Organization",
  //     name: "ISKCON Vijayawada",
  //     url: "https://www.iskconvijayawada.org/",
  //   },
  //   description:
  //     "Sri Radhastami marks the appearance of Srimati Radharani, celebrated with devotional music, prayers, abhishekam, and seva at ISKCON Vijayawada.",
  //   image: [
  //     "https://www.iskconvijayawada.org/static/media/Sri%20Radhastami_Web_Banner.d292009597a5e5773be3.jpg",
  //   ],
  //   offers: {
  //     "@type": "Offer",
  //     url: "https://www.iskconvijayawada.org/radhastami2025",
  //     availability: "https://schema.org/InStock",
  //     price: "0",
  //     priceCurrency: "INR",
  //   },
  //   performer: {
  //     "@type": "Organization",
  //     name: "ISKCON Vijayawada",
  //   },
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* <Helmet>
        <title>Sri Radhastami Celebrations 2025 | ISKCON Vijayawada</title>
        <meta
          name="description"
          content="Celebrate Sri Radhastami, the appearance of Srimati Radharani, at ISKCON Vijayawada Sri Sri Radha Syam Sundar Mandir on August 31st, 2025. Join devotees for music, prayers, offerings, and seva, and embark on your spiritual journey in a sacred atmosphere."
        />
        <meta
          name="keywords"
          content="Sri Radhastami, ISKCON Vijayawada, Srimati Radharani, Lord Krishna, devotional celebrations, bhakti, spiritual guidance, Radha Shyam Sundar, Jagannath Baldev Subhadra, seva, Krishna consciousness, temple events, programs, spiritual journey."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Sri Radhastami Celebrations 2025 | ISKCON Vijayawada"
        />
        <meta
          property="og:description"
          content="Celebrate Sri Radhastami, the appearance of Srimati Radharani, at ISKCON Vijayawada Sri Sri Radha Syam Sundar Mandir on August 31st, 2025. Join devotees for music, prayers, offerings, and seva, and embark on your spiritual journey in a sacred atmosphere."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content=" https://www.iskconvijayawada.org/radhastami2025"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Sri Radhastami Celebrations 2025 | ISKCON Vijayawada"
        />
        <meta
          name="twitter:description"
          content="Celebrate Sri Radhastami, the appearance of Srimati Radharani, at ISKCON Vijayawada Sri Sri Radha Syam Sundar Mandir on August 31st, 2025. Join devotees for music, prayers, offerings, and seva, and embark on your spiritual journey in a sacred atmosphere."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/radhastami2025"
        />
      </Helmet> */}


      {/* <Hero /> */}
      <TextContent />
      <Form />
      <Qrcodes />
      <Footer />
    </div>
  );
};

export default DasaraMahotsav2025;
